class ProductFormVariants extends HTMLElement {
  constructor() {
    super();

    const form = this.closest("form");
    const inputs = this.querySelectorAll('input[type="radio"]');

    inputs.forEach((input) => {
      input.addEventListener('change', () => {
        const variant = get_variant();

        if (!variant) return;

        document.dispatchEvent(new CustomEvent("productformvariants:change", {
          detail: { variant }
        }));

        Theme.URLParams.set("variant", variant.id);

        form.querySelector("[name=id]").value = variant.id;
      });
    });

    function get_variant() {
      const title = Array.from(inputs)
        .filter(el => el.checked)
        .map(el => el.value)
        .join(" / ")
        .trim();

      return Theme.Liquid.product.variants.find(v => v.title === title) || null;
    }
  }
}

customElements.define("product-form-variants", ProductFormVariants);
